// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "LinkReportLink" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";

export const LinkReportLinkGenShape = z.strictObject({
  href: z.string(),
  linkText: z.string(),
  snippetHref: z.string(),
  snippetDescription: z.string().optional(),
  warning: z.boolean(),
  instance: z.number(),
});
